import React, { ChangeEvent } from "react";
import { IInkAndTonerOption } from "./inkAndTonerDropdown";

export interface ISelectYourXDropdownProps {
  arrayForSelection: IInkAndTonerOption[];
  selectYourXDropdownIndex: number;
  callBack: (value: string) => void;
  filterPlaceholderText: string;
}

export interface ISelectYourXDropdownState {
  typeAheadResults: IInkAndTonerOption[];
}

class SelectYourXDropdown extends React.Component<
  ISelectYourXDropdownProps,
  ISelectYourXDropdownState
> {
  constructor(props: ISelectYourXDropdownProps) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      typeAheadResults: [],
    };
  }
  hasTypeAheadResults() {
    return this.state.typeAheadResults.length > 0;
  }
  handleChange(event: ChangeEvent<HTMLInputElement>) {
    let typeAheadResults: IInkAndTonerOption[] = [];
    if (event.target.value) {
      const searchExpression = new RegExp(event.target.value, "i");
      typeAheadResults = this.props.arrayForSelection.filter(function (x) {
        return searchExpression.test(x.label);
      });
    }
    this.setState({ typeAheadResults: typeAheadResults });
  }
  onClick(filterValue: IInkAndTonerOption) {
    if (this.props.callBack) {
      this.props.callBack(filterValue.value);
    }
  }
  createLIElement(filterValue: IInkAndTonerOption) {
    return (
      <li key={filterValue.value}>
        <div onClick={() => this.onClick(filterValue)}>{filterValue.label}</div>
        {/*<Link
            to={{
              pathname:
                "/" +
                (this.props.routePrefix || "") +
                encodeURIComponent(filterValue.description),
              search: this.props.queryString,
            }}
            onClick={() => this.onClick(filterValue.description)}
          >
            {filterValue.description}
          </Link>*/}
      </li>
    );
  }
  render() {
    const filterInputId = "refine" + this.props.selectYourXDropdownIndex;
    return (
      <div className="select-your-x-dropdown">
        <label htmlFor={filterInputId} className="sr-only">
          {"refine" + this.props.filterPlaceholderText}
        </label>
        <input
          type="text"
          id={filterInputId}
          name={filterInputId}
          onChange={this.handleChange}
          placeholder={this.props.filterPlaceholderText}
        />
        {this.hasTypeAheadResults() ? (
          <div className="type-ahead-separator">
            <ul>
              {this.state.typeAheadResults.map((filterValue) =>
                this.createLIElement(filterValue)
              )}
            </ul>
            <hr className="blue narrow" />
          </div>
        ) : null}
        <ul>
          {this.props.arrayForSelection.map((filterValue) =>
            this.createLIElement(filterValue)
          )}
        </ul>
      </div>
    );
  }
}

export default SelectYourXDropdown;
